import {useState} from 'react';

export default function useMessageModel() {
  const [copilotOpen, setCopilotOpen] = useState(false);
  const [robot = {
    status: 'UNSTART'
  }, setRobot] = useState({});

  return {
    copilotOpen,
    setCopilotOpen,
    robot,
    setRobot
  };
}
